// style.js
const spacingVal = (theme, n) => {
  let raw;
  if (typeof theme.spacing === 'function') raw = theme.spacing(n);
  else if (theme.spacing && typeof theme.spacing === 'number') raw = theme.spacing * n;
  else if (theme.spacing && theme.spacing.unit) raw = theme.spacing.unit * n;
  else raw = 8 * n;
  return typeof raw === 'number' ? raw + 'px' : raw;
};

const styles = (theme) => {
  const basePad = spacingVal(theme, 2);
  const smPad = spacingVal(theme, 3);
  const mdPad = spacingVal(theme, 4);

  const hasBpUp = theme && theme.breakpoints && typeof theme.breakpoints.up === 'function';
  const upSm = hasBpUp ? theme.breakpoints.up('sm') : '@media (min-width:600px)';
  const upMd = hasBpUp ? theme.breakpoints.up('md') : '@media (min-width:960px)';
  const phone = '@media (max-width:768px)';

  return {
    content: {
      width: '100%',
      height: '100%',
      margin: 0,
      boxSizing: 'border-box',
      overflowY: 'auto',
      WebkitOverflowScrolling: 'touch',
      padding: basePad,
      paddingTop: 'calc(env(safe-area-inset-top, 0px) + ' + basePad + ')',
      paddingBottom: 'calc(env(safe-area-inset-bottom, 0px) + ' + basePad + ')',
      paddingLeft: 'calc(env(safe-area-inset-left, 0px) + ' + basePad + ')',
      paddingRight: 'calc(env(safe-area-inset-right, 0px) + ' + basePad + ')',
      [upSm]: { padding: smPad },
      [upMd]: { padding: mdPad, maxWidth: 1200, marginLeft: 'auto', marginRight: 'auto' },
    },

    infoWrapper: {
      width: '100%',
      maxWidth: 900,
      margin: '0 auto',
    },
    swaggerWrapper: {
      width: '100%',
      margin: 0,
      maxWidth: 'none',

      '& .swagger-ui .wrapper, & .swagger-ui .information-container, & .swagger-ui .scheme-container': {
        maxWidth: 'none !important',
        margin: '0 !important',
        paddingLeft: 0,
        paddingRight: 0,
        width: '100%',
      },

      // EKLEYİN ↓↓↓  (desktop + mobile için)
      '& .swagger-ui section': {
        padding: '0 !important',
        margin: '0 !important',
      },
      '& .swagger-ui .scheme-container': {
        // üstteki boşluk genelde buradan gelir
        padding: '15px !important',          // dikey padding sıfır
        margin: '0 0 30px !important',     // istersen ufak alt boşluk
        background: 'transparent',         // beyaz panel istemiyorsanız
      },
      '& .swagger-ui .opblock-tag-section': {
        padding: '0 !important',
        margin: '0 !important',
      },

      // (İsteğe bağlı) opblock’lar arası küçük aralık
      '& .swagger-ui .opblock': {
        margin: '0 0 12px !important',
      },

      '& .swagger-ui': { fontSize: 14 },
      [phone]: { '& .swagger-ui': { fontSize: 15 } },

      /* ==== Küçük ekran düzeni ==== */
      [phone]: {
        /* Özet satırı */
        '& .swagger-ui .opblock-summary': {
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 8,
          padding: '8px',
          background: '#f8f9fa',
          borderRadius: 6,
        },
        '& .swagger-ui .opblock-summary-method': { marginRight: 8 },
        '& .swagger-ui .opblock-summary-path': {
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          flex: '1 1 100%',
          fontWeight: 500,
        },
        '& .swagger-ui .opblock-summary-description': {
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          flex: '1 1 100%',
          color: '#555',
        },

        /* Parametre kartları */
        '& .swagger-ui .parameters thead': { display: 'none' },
        '& .swagger-ui .parameters tbody tr': {
          display: 'block',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: 8,
          padding: '12px',
          marginBottom: '14px',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        },
        '& .swagger-ui .parameters td': {
          display: 'block',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          padding: '4px 0',
          lineHeight: 1.5,
        },
        '& .swagger-ui .parameters td.parameters-col_name': {
          fontWeight: 600,
          marginBottom: 4,
          color: '#333',
        },
        '& .swagger-ui .parameters td.parameters-col_description': {
          marginTop: 4,
          color: '#555',
          /* Example Value kapsayıcı tam genişlik */
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block !important',
        },
        '& .swagger-ui .parameters td.parameters-col_description > *': {
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block',
          boxSizing: 'border-box',
        },

        /* Kod blokları (genel) */
        '& .swagger-ui pre, & .swagger-ui code': {
          maxWidth: '100%',
          overflow: 'auto',
          whiteSpace: 'pre',
          padding: '12px',
          borderRadius: 6,
          background: '#2d2d2d',
          color: '#f8f8f2',
          fontSize: '13px',
        },

        /* (1) Example Value gerçek kod bloğu tam genişlik */
        '& .swagger-ui .highlight-code, & .swagger-ui .model-example, & .swagger-ui .example': {
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block',
          boxSizing: 'border-box',
        },
        '& .swagger-ui .highlight-code pre, & .swagger-ui .model-example pre': {
          display: 'block',
          width: '100% !important',
          maxWidth: '100% !important',
          overflowX: 'auto',
          whiteSpace: 'pre',
          padding: '14px',
          borderRadius: '8px',
          background: '#1e1e1e',
          color: '#f5f5f5',
          fontSize: '14px',
          boxSizing: 'border-box',
        },

        /* Response kartları */
        '& .swagger-ui .responses-table thead': { display: 'none' },
        '& .swagger-ui .responses-table tbody tr': {
          display: 'block',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: 8,
          padding: '12px',
          marginBottom: '14px',
          background: '#fff',
          boxShadow: '0 1px 4px rgba(0,0,0,0.05)',
        },
        '& .swagger-ui .responses-table td': {
          display: 'block',
          whiteSpace: 'normal',
          wordBreak: 'break-word',
          overflowWrap: 'anywhere',
          padding: '4px 0',
          lineHeight: 1.5,
        },
        '& .swagger-ui .responses-table td.response-col_status': {
          fontWeight: 600,
          marginBottom: 4,
          color: '#333',
        },
        '& .swagger-ui .responses-table td.response-col_description': {
          marginTop: 4,
          color: '#555',
        },

        /* Form elemanları */
        '& .swagger-ui textarea, & .swagger-ui input[type="text"], & .swagger-ui select': {
          width: '100%',
          boxSizing: 'border-box',
          fontSize: '15px',
          lineHeight: 1.4,
        },

        /* Butonlar */
        '& .swagger-ui .btn, & .swagger-ui .try-out__btn, & .swagger-ui .execute-wrapper .btn': {
          width: '100%',
          minHeight: '44px',
          marginTop: 6,
        },

        /* Sekmeler */
        '& .swagger-ui .tab-header': {
          overflowX: 'auto',
          display: 'flex',
          gap: 8,
        },
        '& .swagger-ui .tab': { padding: '8px 12px' },

        /* (2) Responses header: title üstte, content-type kontrolü altta ve %100 */
        '& .swagger-ui .opblock .opblock-section-header': {
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '6px',
        },
        '& .swagger-ui .opblock .opblock-section-header h4': {
          width: '100%',
          margin: '0 0 6px 0',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls': {
          alignSelf: 'stretch',
          width: '100% !important',
          display: 'block !important',
          margin: 0,
          padding: 0,
          textAlign: 'left',
          boxSizing: 'border-box',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls label': {
          display: 'block',
          width: '100%',
          margin: '0 0 6px 0',
          fontWeight: 600,
          textAlign: 'left',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls .content-type-wrapper, \
       & .swagger-ui .opblock .opblock-section-header .response-controls select': {
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block',
          margin: 0,
          boxSizing: 'border-box',
        },
        /* === Responses: "Response content type" başlık üstte, select altta ve tam genişlik === */
        '& .swagger-ui .opblock .opblock-section-header .response-controls': {
          display: 'grid !important',
          gridTemplateColumns: '1fr',
          justifyItems: 'start',
          alignSelf: 'stretch',
          width: '100% !important',
          gap: '6px',
          margin: 0,
          padding: 0,
          textAlign: 'left',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls label': {
          order: 0,                 // önce label
          display: 'block',
          width: '100%',
          margin: '0 0 6px 0',
          fontWeight: 600,
          textAlign: 'left',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls .content-type-wrapper, \
   & .swagger-ui .opblock .opblock-section-header .response-controls .content-type': {
          order: 1,                 // sonra select kapsayıcısı
          display: 'block !important',
          width: '100% !important',
          maxWidth: '100% !important',
          margin: 0,
          padding: 0,
          boxSizing: 'border-box',
        },
        '& .swagger-ui .opblock .opblock-section-header .response-controls select': {
          width: '100% !important',
          maxWidth: '100% !important',
          display: 'block',
          margin: 0,
          boxSizing: 'border-box',
        },
        /* Tüm swagger blokları için tek hizalama değeri */
        '--mobile-gutter': '12px',

        /* Özet, header, body, parameters, responses: hepsinde aynı soldan/sağdan boşluk */
        '& .swagger-ui .opblock': {
          padding: 0,                        // dış padding yok
          margin: '0 0 12px !important',
        },

        '& .swagger-ui .opblock .opblock-summary, \
     .swagger-ui .opblock .opblock-section-header, \
     .swagger-ui .opblock .opblock-body, \
     .swagger-ui .opblock .parameters-container, \
     .swagger-ui .opblock .responses-wrapper, \
     .swagger-ui .opblock .responses-wrapper .opblock-section, \
     .swagger-ui .opblock .responses-inner': {
          paddingLeft: 'var(--mobile-gutter) !important',
          paddingRight: 'var(--mobile-gutter) !important',
          marginLeft: '0 !important',
          marginRight: '0 !important',
          boxSizing: 'border-box',
        },

        /* Responses tablosu ve kardaki alt elemanlar da aynı hizada olsun */
        '& .swagger-ui .responses-table, \
     .swagger-ui .responses-table tr, \
     .swagger-ui .responses-table td': {
          paddingLeft: '0 !important',  // tablo zaten wrapper’dan padding alıyor
          paddingRight: '0 !important',
        },

        /* Parametre/örnek blokları kart görünümündeyse hizayı bozmasın */
        '& .swagger-ui .parameters tbody tr, \
     .swagger-ui .responses-table tbody tr': {
          marginLeft: 0,
          marginRight: 0,
        },

        /* Renkli sol şerit (border-left) içerik hizasını etkilemesin */
        '& .swagger-ui .opblock': {
          borderLeftWidth: '4px',   // istersen kalınlık
          // içerik paddingle hizalandığı için border solda kalır, içerik kaymaz
        },

        /* (İstersen) özet satır padding'i de aynı standarda çek */
        '& .swagger-ui .opblock-summary': {
          padding: '8px var(--mobile-gutter) !important',
        },

        /* Section başlıkları */
        '& .swagger-ui .opblock .opblock-section-header h4': {
          width: '100%',
          margin: '0 0 6px 0',
        },

         /* Tek seferde hizalama: opblock içindeki yatay padding'leri kaldır */
  '& .swagger-ui .opblock .opblock-body, \
     .swagger-ui .opblock .parameters-container, \
     .swagger-ui .opblock .responses-wrapper, \
     .swagger-ui .opblock .opblock-section': {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    boxSizing: 'border-box',
  },

  /* İçerik blokları tam genişlik olsun */
  '& .swagger-ui .parameters, \
     .swagger-ui .parameters tbody, \
     .swagger-ui .parameters tbody tr, \
     .swagger-ui .responses-wrapper, \
     .swagger-ui .responses-table, \
     .swagger-ui .highlight-code, \
     .swagger-ui .model-example, \
     .swagger-ui .example': {
    width: '100% !important',
    maxWidth: '100% !important',
  },

  /* Özet satırı (üstteki kısa bar) da aynı genişlikte görünsün */
  '& .swagger-ui .opblock-summary': {
    padding: '8px 0 !important',
  },

  /* (İsteğe bağlı) kart iç boşluğu: içerik kenara yapışmasın istiyorsan burada ver */
  '& .swagger-ui .parameters tbody tr, \
     .swagger-ui .responses-table tbody tr': {
    paddingLeft: '12px',
    paddingRight: '12px',
  },
   /* Mobil hizalama değişkenleri */
  '--gutter': '12px',           // kart içi yatay boşluk
  '--left-border': '5px',       // .opblock border-left kalınlığı (tema rengine göre 4/5px olur)

  /* .opblock kartı: soldaki renkli çizgi */
  '& .swagger-ui .opblock': {
    borderLeftWidth: 'var(--left-border)',
    boxSizing: 'border-box',
  },

  /* Kart içindeki bütün yatay kapsayıcılar: aynı hizaya getir */
  '& .swagger-ui .opblock .opblock-summary, \
     .swagger-ui .opblock .opblock-body, \
     .swagger-ui .opblock .opblock-section, \
     .swagger-ui .opblock .parameters-container, \
     .swagger-ui .opblock .responses-wrapper, \
     .swagger-ui .opblock .responses-inner': {
    paddingLeft: 'calc(var(--gutter) - var(--left-border)) !important', /* ← solda border telafisi */
    paddingRight: 'var(--gutter) !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    boxSizing: 'border-box',
  },

  /* Tablolar ve örnek bloklar tam genişlik */
  '& .swagger-ui .parameters, \
     .swagger-ui .responses-table, \
     .swagger-ui .highlight-code, \
     .swagger-ui .model-example, \
     .swagger-ui .example': {
    width: '100% !important',
    maxWidth: '100% !important',
  },

  /* Özet satırı (üst şerit) de aynı gutter ile */
  '& .swagger-ui .opblock-summary': {
    padding: '8px calc(var(--gutter)) 8px calc(var(--gutter) - var(--left-border)) !important',
  },

      },
    },
  };
};

export default styles;
